import React from 'react';

import { HashRouter, Route, Routes } from 'react-router-dom';

import AdminPage from './pages/AdminPage';
import GenitivePage from './pages/GenitivePage';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import StressPage from './pages/StressPage';

const App: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/forms" element={<GenitivePage />} />
        <Route path="/slovnik" element={<StressPage />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
